import { render } from "./playersWindow.vue?vue&type=template&id=19f7e884&scoped=true"
import script from "./playersWindow.vue?vue&type=script&lang=js"
export * from "./playersWindow.vue?vue&type=script&lang=js"

import "./playersWindow.vue?vue&type=style&index=0&id=19f7e884&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19f7e884"

export default script